import React from 'react';
import { Row } from '../../../atoms/row/Row';
import { Typography } from '../../../atoms/typography/Typography';

const ArticleInfoRow = ({ item, t }) => (
  <Row className={'items-center gap-2 pb-2'}>
    {item.authorImg ? (
      <img
        className="rounded-full"
        src={item.authorImg}
        alt={item.authorName}
        loading="lazy"
      />
    ) : item.authorName ? (
      <div className="flex justify-center items-center text-clamp-sm font-bold text-white w-6 h-6 bg-gradient-to-r from-[#00C9BB] to-[#0098CB] rounded-full">
        {item.authorName.charAt(0)}
      </div>
    ) : null}
    {item.authorName && (
      <Typography
        fontVariant={'sm'}
        className={'font-medium !text-customGray-800'}
      >
        {item.authorName}
      </Typography>
    )}
    <Typography fontVariant={'sm'} className={'!text-customGray-600'}>
      {item.date}
    </Typography>
    {item.guest && (
      <Typography
        fontVariant={'sm'}
        className={'bg-secondary-200 text-secondary-900 rounded-lg py-1 px-1'}
      >
        {t('blog.guest')}
      </Typography>
    )}
  </Row>
);

export default ArticleInfoRow;
